var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import MobileConst from "../constants/MobileConst";
import { PromiseUtils } from "@kv-design/kui";
import Action from "../action/Action";
import StoreFactory from "./StoreFactory";
export default class ReduxFactory {
    static config(config) {
        ReduxFactory._config = Object.assign({}, ReduxFactory.defaultConfig, config);
        const { reducers, reduxLoggerEnable, middlewares } = ReduxFactory._config;
        const store = StoreFactory.create({
            reduxLoggerEnable: reduxLoggerEnable,
            middlewares: middlewares,
            reducers: reducers,
        });
        const { dispatch, getState } = store;
        ReduxFactory.reduxDispatch = dispatch;
        ReduxFactory.getState = getState;
        Action.dispatch = ReduxFactory.dispatchAction;
        Action.getState = ReduxFactory.getState;
        return {
            store: store,
        };
    }
}
ReduxFactory.actionMap = new Map();
ReduxFactory.reduxDispatchInitialized = false;
ReduxFactory.actionMethods = {};
ReduxFactory.actionMethodsInitialized = false;
ReduxFactory.defaultConfig = {
    actionLogger: false,
};
ReduxFactory.defaultMapStateToProps = (_a) => {
    var argument = __rest(_a, []);
    return argument;
};
ReduxFactory.defaultMapDispatchToProps = dispatch => {
    return {};
};
ReduxFactory.connect = (mapStateToProps, mapDispatchToProps) => {
    const _mapStateToProps = mapStateToProps ? mapStateToProps : ReduxFactory.defaultMapStateToProps;
    if (!ReduxFactory.actionMethodsInitialized) {
        ReduxFactory.actionMap.forEach(action => {
            Object.assign(ReduxFactory.actionMethods, action);
        });
    }
    const _mapDispatchToProps = mapDispatchToProps ? mapDispatchToProps : ReduxFactory.defaultMapDispatchToProps;
    return ReduxFactory._config.connect(_mapStateToProps, _mapDispatchToProps);
};
ReduxFactory.actions = () => {
    return function (Clazz) {
        console.log(`%c${MobileConst.LOG_PREFIX} Action Loaded => ${Clazz.name}`, "color:#9e9e9e;font-weight:bold;");
        const actionMap = ReduxFactory.actionMap;
        const actionName = Clazz.name;
        if (!actionMap.has(actionName)) {
            actionMap.set(actionName, ReduxFactory.getAdviceMethodsFromInstance(Clazz, ReduxFactory.actionProxy));
        }
        return Clazz;
    };
};
ReduxFactory.actionProxy = (name, method, args = []) => {
    if (ReduxFactory._config.actionLogger) {
        console.groupCollapsed(`${MobileConst.LOG_PREFIX} Action Method => ${name}`);
        args.map((argument, index) => {
            console.log(`Argument(${index}) => `, argument);
        });
        console.groupEnd();
    }
    return method(...args);
};
ReduxFactory.getAdviceMethodsFromInstance = (clazz, proxy) => {
    const methods = {};
    Object.keys(clazz).forEach(name => {
        const method = clazz[name];
        const proxyMethod = ((...argument) => {
            return proxy(name, method, argument);
        });
        clazz[name] = proxyMethod;
        Object.assign(methods, {
            [name]: proxyMethod,
        });
    });
    return methods;
};
ReduxFactory.dispatchAction = (action) => {
    if (!ReduxFactory.reduxDispatchInitialized) {
        PromiseUtils.wait(() => typeof ReduxFactory.reduxDispatch === "function").then(() => {
            ReduxFactory.reduxDispatchInitialized = true;
            ReduxFactory.doDispatchAction(action);
        });
    }
    else {
        ReduxFactory.doDispatchAction(action);
    }
};
ReduxFactory.doDispatchAction = (action) => {
    const prevState = Object.assign({}, ReduxFactory.getState());
    ReduxFactory.reduxDispatch(action);
    const nextState = Object.assign({}, ReduxFactory.getState());
    ReduxFactory.printActionInfo(action, prevState, nextState);
};
ReduxFactory.printActionInfo = (action, prevState, nextState) => {
    console.groupCollapsed(`%c${MobileConst.LOG_PREFIX} Action Dispatch => ${action.type}`, "color:#29b6f6;font-weight:bold;");
    console.log("%cpre state", "color:#9E9E9E;font-weight:bold;", prevState);
    console.log("%caction", "color:#F44336;font-weight:bold;", action);
    console.log("%cnext state", "color:#00BCD4;font-weight:bold;", nextState);
    console.groupEnd();
};
ReduxFactory.getState = () => ReduxFactory.state;
